/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const portfolioChangeEligibilityResponseSchema = z.object({
  assignedItemCount: z.int(),
  eligible: z.boolean(),
  reason: z.enum(['TEAM_HAS_ASSIGNED_ITEMS']).nullish(),
});
